export default __webpack_public_path__ + "static/ForgetSectionLeft_it-04e03d7dff85c3e798868f211cd07e3d.png";